import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/about/page.tsx");
